<template>
  <aside
    class="bg-white w-72 max-w-6xl min-h-screen border-r px-6 py-6 flex flex-col justify-between"
  >
    <!-- Logo & Toggle Button -->
    <div class="flex items-center justify-between mb-6">
      <img
        src="@/assets/logo.png"
        alt="FlyHigh Logo"
        class="w-20"
      >
      <button class="p-2 hover:bg-gray-100 rounded-md">
        <i class="fas fa-table-cells-large text-lg text-gray-500" />
      </button>
    </div>

    <div class="flex items-center mb-6 gap-4">
      <button
        class="md:hidden"
        @click="$emit('toggleSidebar')"
      >
        <i class="fas fa-bars text-xl" />
      </button>
      <div class="relative">
        <input
          type="text"
          placeholder="Search.."
          class="pl-10 pr-4 py-2 border rounded-full bg-transparent focus:outline-none"
        >
        <i
          class="fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
        />
        <span
          class="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-400 border border-gray-300 px-1 rounded"
        >
          ⌘ F
        </span>
      </div>
    </div>

    <div class="flex-1">
      <p class="text-[11px] text-gray-400 font-semibold mb-2">
        GENERAL
      </p>
      <nav class="space-y-1 mb-6">
        <SidebarItemComponent
          icon="fas fa-th"
          :text="t('bottomBar.home')"
          to="/home"
        />
        <SidebarItemComponent
          icon="fas fa-signal"
          :text="t('bottomBar.quiz')"
          to="/quiz"
        />
        <SidebarItemComponent
          icon="fas fa-gift"
          :text="t('bottomBar.ranking')"
          to="/ranking"
        />
        <SidebarItemComponent
          v-if="canBuildTutorQuiz"
          icon="fas fa-pen-nib"
          text="Tutor Quiz"
          to="/tutor/quiz-builder"
        />
      </nav>

      <!-- MANAGE -->
      <p class="text-[11px] text-gray-400 font-semibold mb-2">
        MANAGE
      </p>
      <nav class="space-y-1">
        <SidebarItemComponent
          v-if="isAdmin"
          icon="fas fa-user-shield"
          text="User Access"
          to="/admin/user-access"
        />
        <SidebarItemComponent
          icon="fas fa-chart-bar"
          :text="t('bottomBar.profile')"
          to="/settings"
        />
      </nav>
    </div>
  </aside>
</template>

<script setup>
import SidebarItemComponent from "./SidebarItemComponent.vue";
import { useI18n } from "vue-i18n";
import { computed, onMounted, ref } from "vue";
import { useAuthStore } from "@/stores/authStore";
import { GetProfile } from "@/api/settingApi";

const { t } = useI18n();
const auth = useAuthStore();

const profile = ref(null);
const userType = computed(() => {
  const type =
    profile.value?.userType ??
    profile.value?.UserType ??
    auth.userType ??
    auth.user?.userType ??
    "";
  return typeof type === "string" ? type.toLowerCase() : "";
});

const isTutor = computed(() => userType.value === "tutor");
const isAdmin = computed(() => userType.value === "admin");
const canBuildTutorQuiz = computed(() => isTutor.value || isAdmin.value);

const loadProfile = async () => {
  try {
    if (!auth.userId) return;
    const res = await GetProfile(auth.userId);
    profile.value = res ?? null;
    const profileRole = res?.userType ?? res?.UserType ?? "";
    if (profileRole && (!auth.user || !auth.user.userType)) {
      auth.user = { ...(auth.user || {}), userType: profileRole };
    }
  } catch (error) {
    console.error("Sidebar profile fetch failed:", error);
  }
};

onMounted(loadProfile);
</script>
